import React from 'react';
import ReactDOM from 'react-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { useTheme } from './ThemeContext';
import './FloatingBackButton.css';

interface FloatingBackButtonProps {
  onBack: () => void;
  position?: 'top-left' | 'bottom-center';
  variant?: 'minimal' | 'with-text' | 'ghost';
  mode?: 'portal' | 'inline';
  text?: string;
  ariaLabel?: string;
  className?: string;
  isMobileView?: boolean;
}

const FloatingBackButton: React.FC<FloatingBackButtonProps> = ({
  onBack,
  position = 'top-left',
  variant = 'minimal',
  mode = 'portal',
  text = 'Retour',
  ariaLabel = 'Retour',
  className = '',
}) => {
  const { theme } = useTheme();

  const buttonVariants = {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
    hover: { scale: 1.05 },
    tap: { scale: 0.95 },
  };

  const buttonClasses = [
    'floating-back-button',
    mode === 'portal' ? `position-${position}` : null,
    `variant-${variant}`,
    `mode-${mode}`,
    theme,
    className,
  ].filter(Boolean).join(' ');

  const button = (
    <motion.button
      onClick={onBack}
      className={buttonClasses}
      variants={buttonVariants}
      initial="initial"
      animate="animate"
      whileHover="hover"
      whileTap="tap"
      transition={{ duration: 0.2 }}
      aria-label={ariaLabel}
    >
      <ArrowLeft size={variant === 'minimal' ? 24 : 20} className="back-icon" />
      {variant !== 'minimal' && <span className="back-text">{text}</span>}
    </motion.button>
  );

  if (mode === 'inline') return button;
  return ReactDOM.createPortal(button, document.body);
};

export default FloatingBackButton;
